import { ApeironTooltipInfoButton } from '@apeiron/ui'
import { Box, styled, Typography } from '@mui/material'
import * as R from 'ramda'
import { FC, ReactNode } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`

const TitleContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 10px;
`

const Title = styled(Typography)`
  color: #8b8b8b;
  font-size: 20px;
  font-weight: 500;
  line-height: 20px;
`

const Text = styled(Typography)`
  font-weight: 400;
  ${props => props.theme.breakpoints.up('res1024')} {
    font-size: 42px;
    line-height: 42px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    font-size: 22px;
    line-height: 22px;
  }
`

const Subtext = styled(Text)`
  color: #8b8b8b;
  display: inline;
  font-size: 36px;
  font-weight: 300;
  line-height: 36px;
  margin-left: 8px;
`

const Remark = styled(Typography)`
  color: #8b8b8b;
  font-size: 20px;
  font-weight: 300;
  height: 20px;
  line-height: 20px;
`

const TextContent: FC<TextContentProps> = props => {
  const { content } = props

  const { remark, subtext, text } = content

  return (
    <>
      <Text>
        {text}
        <Subtext>{subtext}</Subtext>
      </Text>
      <Remark>{remark}</Remark>
    </>
  )
}

const VestingSummaryDataSection: FC<Props> = props => {
  const { content, info, title } = props

  return (
    <Container>
      <TitleContainer>
        <Title>{title}</Title>
        {R.isNotNil(info) && (
          <ApeironTooltipInfoButton tooltipId={'vesting-tips'}>
            {info}
          </ApeironTooltipInfoButton>
        )}
      </TitleContainer>
      {R.has('remark', content) ? <TextContent content={content} /> : content}
    </Container>
  )
}

type TextData = {
  remark: string
  subtext: string
  text: string
}

type TextContentProps = {
  content: TextData
}

type Props = {
  content: ReactNode | TextData
  info?: string
  title: string
}

export default VestingSummaryDataSection
